import { render, staticRenderFns } from "./AgreementHokkokubank.vue?vue&type=template&id=6de06b78&scoped=true&"
import script from "./AgreementHokkokubank.vue?vue&type=script&lang=ts&"
export * from "./AgreementHokkokubank.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementHokkokubank.vue?vue&type=style&index=0&id=6de06b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de06b78",
  null
  
)

export default component.exports